angular.module("clientDashboardApp.admin").directive("specialschedule", () => {
  return {
    restrict: 'E',
    require: '^form',
    scope: {
      index: '=',
      model: '=',
      period: '=',
      specialhours:'='
    },
    template: require("./specialSchedule.html")
    ,
    link: (scope, el, attrs, formController) => {
      scope.formController = formController;
    },
    controller($scope) {
      //time check
      $scope.isValidTimeRange = (start, end) => {
        let startTime = moment(start, "HH:mm a");
        let endTime = moment(end, "HH:mm a");

        return (startTime.isBefore(endTime))
      };
      //link that toggles closed
      $scope.toggleSpecialHoursClosed = (period) => {
        period.isClosed = !period.isClosed;
        $scope.specialDayCloseAction(period);
      };
      //action when closed button clicked
      $scope.specialDayCloseAction = (period) => {
        //set the hours to 12:00AM for compatibility if clicked and closed
            period.openTime = "";
            period.closeTime ="";
      };



      $scope.removeSpecialHourPeriod = (index) => {
        $scope.specialhours.splice(index, 1)
        $scope.formController.$setDirty()
        $scope.validateAllPeriodErrors()

        if (!$scope.hasAnyPeriodErrors()) {
          //remove any invalids from the form due to special hours at parent scope
          $scope.$emit("validateDateRange", {isValidDateRange: true})
          $scope.formController.$setValidity("specialHolidayHoursPeriod", true)
        }

      };

      /* Helper goes over all time periods in the form date and time pickers
       * any errors found go into each period's model special error array of objects.
       * when no errors are found it removes the error array per period.
      * */
      $scope.validateAllPeriodErrors = () => {
        $scope.specialhours.forEach((period, periodIndex)=>{
          let isTimeRangeValid = $scope.isValidTimeRange(
            period.openTime,
            period.closeTime
          );

          period.errors = {invalidTimeRange:null}

          if (isTimeRangeValid){
            delete period.errors.invalidTimeRange
          } else {
            period.errors.invalidTimeRange = true
          }

          if (_.isEmpty(period.errors)) delete period.errors
        })

      }

      /*checks all error arrays for existence to determine
      if model has not passed validation*/
      $scope.hasAnyPeriodErrors = (periods = $scope.specialhours) => {
        for (let period of periods){
          if (period.errors) return true
        }
        return false
      }


      /*
      * updates the model for date range. Called each time child date input is updated.
      * rawDate [string] formatted date from child directive
      * boundary [string] declared at directives html attr "end || start"
      *     used to map each model with its special date format per input.
      *     (time inputs don't need this because they are single properties with simple formatting)
      * */
      $scope.updateModel = (rawDate, boundary) => {
        const period = $scope.period

        const updateSpecialDate = (periodBoundary, rawDate) => {
          const dateSpecialObject = rawDate.split("/")
          periodBoundary.rawDate = rawDate
          periodBoundary.month = dateSpecialObject[0]
          periodBoundary.day = dateSpecialObject[1]
          periodBoundary.year = dateSpecialObject[2]
        }

       const periodBoundaries = {
          start: period.specialStartDate,
          end: period.specialStartDate
       }

        updateSpecialDate(periodBoundaries[boundary], rawDate);

      }

    },
    transclude: true
  };

  });


